import { HostListener, Component, ViewChild, OnInit, AfterViewInit, Input, ElementRef, Renderer2 } from '@angular/core';
import * as Highcharts from 'highcharts';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { ApiMethod } from '../apimethods/api-method';
import * as ngswal from "sweetalert";
import { GlobalConstants } from '../common/global-constants';
import { empty } from 'rxjs';
import { PieChartComponent } from '../Defect-mgt-childcomponents/pie-chart/pie-chart.component';
import { TopDisplayPannelComponent } from '../Defect-mgt-childcomponents/top-display-pannel/top-display-pannel.component';
import { MasterGridComponent } from '../Defect-mgt-childcomponents/master-grid/master-grid.component';
import { customfunctions, DataParam } from '../common/customfunctions';
import { DefectResponseComponent } from '../Defect-mgt-childcomponents/defect-response/defect-response.component';
import { DefectNewComponent } from '../Defect-mgt-childcomponents/defect-new/defect-new.component';

declare var $;

@Component({
  selector: 'app-defect-mgt-dashboard',
  templateUrl: './defect-mgt-dashboard.component.html',
  styleUrls: ['./defect-mgt-dashboard.component.css']
})

export class DefectMgtDashboardComponent implements OnInit, AfterViewInit {
  @ViewChild('statuspannel', { static: true }) status: TopDisplayPannelComponent;//child component
  @ViewChild('RCApannel', { static: true }) RCAStatus: TopDisplayPannelComponent;//child component
  /* @ViewChild('prioritypannel', { static: true }) priority: TopDisplayPannelComponent;//child component*/
  @ViewChild('dueStatusCount', { static: true }) dueStatusCt: TopDisplayPannelComponent;//child component
  @ViewChild('IRstatus', { static: true }) IRstatus: MasterGridComponent;//child component
  @ViewChild('ARstatus', { static: true }) ARstatus: MasterGridComponent;//child component
  @ViewChild('DueStatus', { static: true }) DueStatus: MasterGridComponent;//child component
  @ViewChild('defectResponse', { static: true }) defectResponse: DefectResponseComponent;//child component
  @ViewChild('newDefect', { static: true }) newDefect: DefectNewComponent;//child component
  @ViewChild('piechart', { static: true }) piechart: PieChartComponent;//child component
  @ViewChild('tooltipBtn') tooltipBtn!: ElementRef;
  showModal: boolean;
  dataTable: any;
  @ViewChild('dataTable', { static: false }) table;
  dataSetDefectRes: any;
  dataSet: any;
  ajournalCt = [];
  journal: any = 0;
  defectstatus: any = 'AllIR';
  DefectSatus: any;
  disableScrollDown = false;
  journalName: any;
  volumeIssue: any;
  articleNo: any;
  defectAreaName: any;
  defectCategory: any;
  defectInstructions: any;
  responsibleUser: any;
  complaintType: any;
  currentStatus: any;
  criticalStatus: any;
  implementDate: any;
  problemDate: any;
  defectDueDate: any;
  dueStatus: any;
  description: any;
  rootCause: any;
  daysOnDue: any;
  rootCauseBy: any;
  rootCauseDate: any;
  preventiveAct: any;
  preventiveActBy: any;
  preventiveActDate: any;
  correctiveAction: any;
  correctiveActBy: any;
  correctiveActDate: any;
  feedback: any;
  ChartData: any = [];
  header: any;
  nPublisherId: any;
  statusheader: any = [];
  priorityDetails: any;
  priorityData: any = [];
  statusDetailsdata: any;
  mastergridstatus: any = 'AllIR';
  title: string;
  dtOptions: any;
  tableData = [];
  ajournalAccess: any;
  User: any;
  showButton: boolean = true;
  GetDefectCategoryList: any;
  journalList: any; issueList: any; articleList: any;
  DefectAreaList: any; DefectCategoryList: any; DefectInstructionList: any;
  DefectStatusListAPI: any;
  CategoryIdPop: any; Acronym: string; ArticleNo: string; VolIssue: string; AreaName: string;
  Category: string; Instructions: string; ResponseMode: string;
  Volume: any;
  Description: any;
  DownloadFilepath: any;
  popUpButtonText: string;
  Response: string;
  file: any;
  fileBase64: any;
  FileName: any;
  uploadFilePath: any;
  RequestFeedback: any;
  reportTypeList: any;
  DefectDueDate: any;
  disableValidation: boolean = false;
  minDate: string;
  maxDate: string;
  DefectStatus: string;
  selectedValue: string = '';
  chkRootCause: string;
  chkPreventiveAction: string;
  chkCorrectiveAction: string;
  chkRootCauseUser: boolean;
  chkPreventiveUser: boolean;
  chkCorrectiveUser: boolean;
  showModalUR: boolean;
  DefectSatuses: any;
  RCPStatus: any;
  DueStatuses: any;
  modelItem: any;
  showExcelPopupBody: boolean;
  showExcelValidationPopup: boolean;
  LocalFilePath: any;
  hideExcelModalButton: string = "Upload"




  constructor(private router: Router, http: HttpClient) {

    this.nPublisherId = localStorage.aPubID;
    localStorage.aEID = 0;
    this.GetStatusPannelData();
    /* this.GetPriorityPannelData();*/
    this.GetRCAStatusPannelData();
    this.GetDueStatus();
    $('#divdefectResponse').hide();
    $('#divnewDefect').show();
    this.checkAccess();

  }

  ngOnInit(): void {

    this.IRstatus.showStatus = 'IRstatus';
    $('#divOverall').css('height', (GlobalConstants.size.height) - 200);

    this.getJournalAll();

    $("#DefectStatus").select2({
      placeholder: "Select Status", dropdownParent: "#divResponseData"
    });
    $("#DefectStatus").val([]).trigger("change");

  }
  ngAfterViewInit(): void {
    // to refresh the page if any add / update done in response/add screen
    this.newDefect.recordSaved.subscribe(() => {
      this.refresh();
    });
    this.defectResponse.recordUpdated.subscribe(() => {
      this.refresh();
    });

  }

  hideDataTableActionForRPuser() {

    if (this.User == 'Response') {

      const table = document.getElementById('tbljournalissue');

      const columnIndex = Array.from(table.querySelectorAll('th'))
        .findIndex(th => th.textContent.trim() === 'Actions');

      if (columnIndex !== -1) {
        table.querySelectorAll('th')[columnIndex].style.display = 'none';
        table.querySelectorAll('tr').forEach(row => {
          row.querySelectorAll('td')[columnIndex].style.display = 'none';
        });
      }
    }

  }

  GetUserRoles(): void {
    this.showModalUR = true;

  }
  hideUserRoles(): void {
    this.showModalUR = false;

  }
  refresh(): void {
    this.GetStatusPannelData();
    /* this.GetPriorityPannelData();*/
    this.GetRCAStatusPannelData();
    this.GetDueStatus();
    this.piechart.GetPieChartDetails();
    this.IRstatus.showStatus = 'IRstatus';
    this.mastergridstatus = 'AllIR'
    this.IRstatus.getJournalCount();
    this.getJournalAll();

  }
  createNewDefect(): void {

    this.newDefect.DefectId = localStorage.aEID;
    this.newDefect.DefectStatus = 'Defect';
    this.newDefect.showData();


    $('#divdefectResponse').hide();
    $('#divnewDefect').show();

  }
  checkUserLevelAccess(): void {

    if (localStorage.aEID != 0) {
      var dataParam = {
        Id: localStorage.aEID,
        UpdatedBy: localStorage.aLoginID,
      };


      ApiMethod.postMethod('api/populatedefectmgt', dataParam).subscribe(
        result => {
          let _dataItem = result.DataItem;
          let _defectdata = result.defectData;
          var menuList = JSON.parse(localStorage.aMenuList);

          const DefectManagement = menuList.find(
            (menuItem) => menuItem.MenuID == 17);
          var DefectResponse = menuList.find(
            (menuItem) => menuItem.MenuID == 57);

          var RootCauseAnalysis = menuList.find(
            (menuItem) => menuItem.MenuID == 77);

          var PreventiveAction = menuList.find(
            (menuItem) => menuItem.MenuID == 78);

          var CorrectiveAction = menuList.find(
            (menuItem) => menuItem.MenuID == 79);

          var Approver = menuList.find((menuItem) => menuItem.MenuID == 87);
          var Reject = menuList.find((menuItem) => menuItem.MenuID == 88);


          this.chkRootCause = _dataItem[0].RootCasue;
          this.chkPreventiveAction = _dataItem[0].PreventiveAction;
          this.chkCorrectiveAction = _dataItem[0].CorrectiveAction;
          this.chkRootCauseUser = RootCauseAnalysis.Action.toLowerCase().includes('update');
          this.chkPreventiveUser = PreventiveAction.Action.toLowerCase().includes('update');
          this.chkCorrectiveUser = CorrectiveAction.Action.toLowerCase().includes('update');

          if (_defectdata[0].DefectViewProcess == 'Response') {//for RPC user
            this.User = 'Response';
          }
          if (_defectdata[0].DefectViewProcess == 'Add') {//for super user view
            this.User = 'Add';

          }

          //super user with root cause access  and root cause not given
          if (this.chkRootCauseUser && this.User == 'Add' && (this.chkRootCause == null || this.chkRootCause == '')) {

            this.defectResponse.ResponseMode = 'Response';

            this.defectResponse.ShowInfoPopUp();

          }
          else if (this.chkPreventiveUser && this.User == 'Add' && (this.chkPreventiveAction == null || this.chkPreventiveAction == '')) {

            this.defectResponse.ResponseMode = 'Response';

            this.defectResponse.ShowInfoPopUp();
          }
          else if ((this.chkCorrectiveUser && this.User == 'Add' && (this.chkCorrectiveAction == null || this.chkCorrectiveAction == ''))) {

            this.defectResponse.ResponseMode = 'Response';

            this.defectResponse.ShowInfoPopUp();

          }
          else if (this.User == 'Add') {//for super user view

            this.defectResponse.ResponseMode = 'Add';
            this.defectResponse.ShowDataResponse();
          }
          else if (this.User == 'Response') {//for RPC user

            this.defectResponse.ResponseMode = 'Response';
            this.defectResponse.ShowInfoPopUp();
          }

        }, error => {
          $("#LoadingImage").hide();
          ngswal("Failed !", error.message, "warning");
        });

    }

  }

  checkAccess(): void {

    var paramData = {
      LoginID: localStorage.aLoginID,
      PublisherID: localStorage.aPubID

    };

    ApiMethod.postMethod('api/journalAccess', paramData).subscribe(
      Response => {
        console.log(Response);
        let userCount = Response.userCount[0].Action;
        this.ajournalAccess = userCount;

        if (this.ajournalAccess == 'Response') {
          this.showButton = false;
          this.User = 'Response';

        } else if (this.ajournalAccess == 'Add') {

          this.showButton = true;
          this.User = 'Add';
        }

      }, error => {

        ngswal("Failed !", error.message, "error");
      }
    );

  }
  //Response Status View UI Add and Response from sheeshma
  ShowDataResponseparent(): void {

    this.checkUserLevelAccess();

    //component for response
    $('#divdefectResponse').show();
    //component for create/update defect
    $('#divnewDefect').hide();
  }



  //Journal Grid Nav bar

  GetViewList(item): void {
    if (item == 'List') {
      this.IRstatus.showStatus = 'IRstatus';
      this.mastergridstatus = 'AllIR'
      this.IRstatus.getJournalCount();
      this.getJournalAll(); //To load the MainGridTable

      $('#divDashListbased').show();
      $('#divduestatus').hide();
      $('#divDashGraphBased').hide();
      $('#divApproveReject').hide();
    }
    if (item == 'Graph') {
      $('#divduestatus').hide();
      this.piechart.GetPieChartDetails();

      this.mastergridstatus = 'AllIR'
     this.getJournalAll();
      $('#divDashListbased').hide();
      $('#divDashGraphBased').show();
      $('#divApproveReject').hide();
    }
    if (item == 'List1') {
      this.ARstatus.showStatus = 'ARstatus';
      this.mastergridstatus = 'AllAR'
     this.getJournalAll();
      this.ARstatus.getJournalCountAR();

      $('#divduestatus').hide();
      $('#divDashListbased').hide();
      $('#divDashGraphBased').hide();
      $('#divApproveReject').show();
    }
    if (item == 'List2') {

      this.IRstatus.showStatus = 'IRstatus';
      this.mastergridstatus = 'AllIR'
      this.DueStatus.showStatus = 'Due';
      this.DueStatus.getJournalCount();
      this.getJournalAll();
      $('#divDashListbased').hide();
      $('#divDashGraphBased').hide();
      $('#divApproveReject').hide();
      $('#divduestatus').show();


    }
  }
  getJournalAll(): void {

    if (this.mastergridstatus == 'AllIR' || this.mastergridstatus == 'Inprocess' || this.mastergridstatus == 'Response') {
      this.defectstatus = 'AllIR';
    }

    if (this.mastergridstatus == 'AllAR') { this.defectstatus = 'AllAR'; }

    var eventData = {
      journal: this.journal,
      defectstatus: this.defectstatus
    };

    var _statusData = {
      DefectSatuses: this.DefectSatuses,

    };
    var _responseData = {
      RCPStatus: this.RCPStatus,
    };
    var _dueSatusData = {
      DueStatuses: this.DueStatuses,
    };
    this.getJournalAllList(eventData);
    //this.getStatusAllList(_statusData);
    //this.getRCAAllList(_responseData);
    //this.GetDueStatusAllList(_dueSatusData);
  }
  public hide(): void {
    this.showModal = false;
  }
  ShowData(): any {
    var dataParam = {
      PublisherId: localStorage.aPubID,
      defectId: localStorage.aEID,
      LoginID: localStorage.aLoginID
    };
    $("#LoadingImage").show();
    ApiMethod.postMethod('api/defectResponseDetails', dataParam).subscribe(
      response => {
        let defectDetails = response.defectDetailsById;
        //Show Data
        if (defectDetails.length != 0) {
          this.journalName = defectDetails[0].Acronym;
          this.volumeIssue = defectDetails[0].IssueId;
          this.articleNo = defectDetails[0].ArticleNo;
          this.defectAreaName = defectDetails[0].AreaName;
          this.defectCategory = defectDetails[0].category;
          this.defectInstructions = defectDetails[0].Instructions;
          this.responsibleUser = defectDetails[0].ResponsiblePerson;
          this.complaintType = defectDetails[0].complaintType;
          this.currentStatus = defectDetails[0].currentstatus;
          this.criticalStatus = defectDetails[0].CriticalLevel;
          this.implementDate = GlobalConstants.SetValue_FormatDate(defectDetails[0].ImplementDate);
          this.problemDate = GlobalConstants.SetValue_FormatDate(defectDetails[0].Problemdate);
          this.defectDueDate = GlobalConstants.SetValue_FormatDate(defectDetails[0].DefectDueDate);
          this.dueStatus = defectDetails[0].DueStatus;
          this.description = defectDetails[0].Description;
          this.rootCause = defectDetails[0].RootCasue;
          this.rootCauseBy = defectDetails[0].rootcasueby;
          this.rootCauseDate = GlobalConstants.SetValue_FormatDate(defectDetails[0].RootCasueDate);
          this.preventiveAct = defectDetails[0].PreventiveAction;
          this.preventiveActBy = defectDetails[0].preventiveActionBy;
          this.preventiveActDate = GlobalConstants.SetValue_FormatDate(defectDetails[0].PreventiveActionDate);
          this.correctiveAction = defectDetails[0].CorrectiveAction;
          this.correctiveActBy = defectDetails[0].correctiveactionby;
          this.correctiveActDate = GlobalConstants.SetValue_FormatDate(defectDetails[0].CorrectiveActionDate)
          this.feedback = defectDetails[0].ProductionResponse;
          this.daysOnDue = Math.abs(defectDetails[0].DaysOnDue);
        }

        $("#LoadingImage").hide();
      },
      error => {
        ngswal("Failed !", error.message, "error");
        $("#LoadingImage").hide();
      }

    );
    this.showModal = true;

  }
  public GetStatusPannelData(): any {
    $("#LoadingImage").show();

    var paramData = {
      LoginID: localStorage.aLoginID,
      PublisherID: localStorage.aPubID

    };
    ApiMethod.postMethod('api/statuscard', paramData).subscribe(
      response => {

        let statusDetailsdata = response.statusDetails;
        let statusData: any = [];
        $(statusDetailsdata).each(function (index, val) {
          statusData.push({ Count: val.Count, Header: val.Statustext });

        });

        this.status.MainHeader = "Status ";
        this.status.cardheader1 = statusData[0].Header;
        this.status.cardheader2 = statusData[1].Header;
        this.status.value1 = statusData[0].Count;
        this.status.value2 = statusData[1].Count;
        this.status.totalStatus = this.status.value1 + this.status.value2;
        this.status.header = "1";

        $("#LoadingImage").hide();

      },
      error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      }
    );


  }

 


  public GetDueStatus(): any {
    $("#LoadingImage").show();
    var paramData = {
      LoginID: localStorage.aLoginID,
      PublisherID: localStorage.aPubID

    };

    ApiMethod.postMethod('api/DueCount', paramData).subscribe(
      response => {
        console.log(response);
        let defectDuecount = response.defectDuecount;

        this.dueStatusCt.MainHeader = "Due Status";
        this.dueStatusCt.cardheader1 = "Over Due";
        this.dueStatusCt.cardheader2 = "On Due";
        this.dueStatusCt.cardheader3 = "Due For";
        if (defectDuecount[0].OverDue != null) {
          this.dueStatusCt.value1 = defectDuecount[0].OverDue;

        } else {
          this.dueStatusCt.value1 = 0;
        }
        if (defectDuecount[0].OnDue != null) {
          this.dueStatusCt.value2 = defectDuecount[0].OnDue;
         

        }
        else {
          this.dueStatusCt.value2 = 0;
        }

        if (defectDuecount[0].DueFor != null) {
          this.dueStatusCt.value3 = defectDuecount[0].DueFor
        }
        else {
          this.dueStatusCt.value3 = 0;
        }


        this.dueStatusCt.totaloverdue = this.dueStatusCt.value1 + this.dueStatusCt.value2 + this.dueStatusCt.value3 ;
        this.dueStatusCt.header = "3";
        $("#LoadingImage").hide();


      },
      error => {
        ngswal("Failed !", error.message, "error");
        $("#LoadingImage").hide();
      }
    );
  }

  public GetRCAStatusPannelData(): any {
    $("#LoadingImage").show();

    var paramData = {
      LoginID: localStorage.aLoginID,
      PublisherID: localStorage.aPubID

    };
    ApiMethod.postMethod('api/piechartDetails', paramData).subscribe(
      response => {
        let PieChartDetails = response.CriticalStatus;
        let RCAStatusData: any = [];
        $(PieChartDetails).each(function (index, val) {
          RCAStatusData.push({ Count: val.Count, Header: val.CurrentStatus });

        });

        this.RCAStatus.MainHeader = "Current Stage ";
        this.RCAStatus.cardheader1 = "RCA";
        this.RCAStatus.cardheader2 = "Preventive";
        this.RCAStatus.cardheader3 = "Corrective";
        this.RCAStatus.value1 = RCAStatusData[0].Count;
        this.RCAStatus.value2 = RCAStatusData[1].Count;
        this.RCAStatus.value3 = RCAStatusData[2].Count;
        this.RCAStatus.totalRCAStatus = this.RCAStatus.value1 + this.RCAStatus.value2 + this.RCAStatus.value3;
        this.RCAStatus.header = "2";
        $("#LoadingImage").hide();
      },
      error => {
        ngswal("Failed !", error.message, "error");
        $("#LoadingImage").hide();
      }
    );
  }



  getJournalAllList(eventData: { journal: any, defectstatus: any }): void {

    if (eventData.defectstatus == 'Journal') {

      this.newDefect.DefectStatus = 'Journal';
      this.newDefect.journalIdfromMaster = eventData.journal;
      this.newDefect.showData();
      $('#divdefectResponse').hide();
      $('#divnewDefect').show();

    } else {
      this.mastergridstatus = eventData.defectstatus;
      let nPublisherId = localStorage.aPubID;

      $("#LoadingImage").show();
      var paramData = {
        LoginID: localStorage.aLoginID,
        PublisherID: localStorage.aPubID,
        JournalId: eventData.journal,
        defectStatus: eventData.defectstatus
      };
      console.log(paramData);
      ApiMethod.postMethod('api/journalDetails', paramData).subscribe(
        result => {
          var journalDefectList = result.journalDetails;
          var journalCount = result.journalDetails.length;

          this.dataSet = JSON.stringify(result.journalDetails); // Data List
          console.log(result.journalDetails);
          this.dataSet = JSON.parse(this.dataSet);
          this.dataTable = $(this.table.nativeElement);
          //Dynamic datable
          let aColList = result.aColListL;
          let dataItem = new DataParam();
          dataItem.acolList = aColList;
          dataItem.aNewButtonName = 'btn_AddNew';
          dataItem.dataTable = this.dataTable;
          dataItem.dataset = this.dataSet;
          dataItem.dtheight = (GlobalConstants.size.height - 350);
          dataItem.modulename = 'DefecMgtDashboard';
          dataItem.rowSelect = true;
          dataItem.infoPopupID = "Id";
          this.dataTable = customfunctions.dynamicDataTable(dataItem);
          console.log(this.dataTable);
          //Dynamic datable

          $("#tbljournalissue_wrapper tbody tr").each(function () {
            var tdValue = $(this).find('td:eq(7)').text();

            if (tdValue == 'OverDue') {
              $(this).css('color', 'Orange');
            } else {
              $(this).css('color', '');
            }
          });


          $("#LoadingImage").hide();

          if (this.showButton == false) {
            $(".spAddIcon").hide();
            $(".spUpdateIcon").hide();
            $('span[title="Edit"]').hide();

          }

          if (this.mastergridstatus == 'AllAR' || this.mastergridstatus == 'Reject' || this.mastergridstatus == 'Approve') {

            $(".spUpdateIcon").hide();
            $('span[title="Edit"]').hide();
          }
          $('button[title="Add new item"]').attr('title', 'Add New Defect');
          $('span[title="Edit"]').attr('title', 'Response');
          $(".spCol spPopup").attr('title', 'View Response');
          $("#LoadingImage").hide();
        },
        error => {
          $("#LoadingImage").hide();
          ngswal("Failed !", error.message, "warning");
        }
      );


    }
  }

  getStatusAllList(eventData: { DefectSatuses: any }): void {

    //if (eventData.defectstatus == 'Journal') {

    //  this.newDefect.DefectStatus = 'Journal';

    //  this.newDefect.showData();
    //  $('#divdefectResponse').hide();
    //  $('#divnewDefect').show();

    //} else {
    //  this.mastergridstatus = eventData.defectstatus;
    //  let nPublisherId = localStorage.aPubID;

    $("#LoadingImage").show();
    var paramData = {
      LoginID: localStorage.aLoginID,
      PublisherID: localStorage.aPubID,
      DefectSatuses: eventData.DefectSatuses,

    };
    console.log(paramData);
    ApiMethod.postMethod('api/StatusGridDetails', paramData).subscribe(
      result => {
        var journalDefectList = result.journalDetails;
        var journalCount = result.journalDetails.length;

        this.dataSet = JSON.stringify(result._statusDetails); // Data List
        this.dataSet = JSON.parse(this.dataSet);
        this.dataTable = $(this.table.nativeElement);
        //Dynamic datable
        let aColList = result.aColListL;
        let dataItem = new DataParam();
        dataItem.acolList = aColList;
        dataItem.aNewButtonName = 'btn_AddNew';
        dataItem.dataTable = this.dataTable;
        dataItem.dataset = this.dataSet;
        dataItem.dtheight = (GlobalConstants.size.height - 350);
        dataItem.modulename = 'DefecMgtDashboard';
        dataItem.rowSelect = true;
        dataItem.infoPopupID = "Id";
        this.dataTable = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable

        $("#tbljournalissue_wrapper tbody tr").each(function () {
          var tdValue = $(this).find('td:eq(7)').text();

          if (tdValue == 'OverDue') {
            $(this).css('color', 'Orange');
          } else {
            $(this).css('color', '');
          }
        });


        $("#LoadingImage").hide();

        if (this.showButton == false) {
          $(".spAddIcon").hide();
          $(".spUpdateIcon").hide();
          $('span[title="Edit"]').hide();

        }

        if (this.mastergridstatus == 'AllAR' || this.mastergridstatus == 'Reject' || this.mastergridstatus == 'Approve') {

          $(".spUpdateIcon").hide();
          $('span[title="Edit"]').hide();
        }
        $('button[title="Add new item"]').attr('title', 'Add New Defect');
        $('span[title="Edit"]').attr('title', 'Response');
        $(".spCol spPopup").attr('title', 'View Response');
        $("#LoadingImage").hide();
      },
      error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      }
    );
  }


  getRCAAllList(eventData: { RCPStatus: any }): void {

    $("#LoadingImage").show();
    var paramData = {
      LoginID: localStorage.aLoginID,
      PublisherID: localStorage.aPubID,
      RCPStatus: eventData.RCPStatus,

    };
    console.log(paramData);
    ApiMethod.postMethod('api/ResponseGridDetails', paramData).subscribe(
      result => {
        var journalDefectList = result.journalDetails;
        var journalCount = result.journalDetails.length;

        this.dataSet = JSON.stringify(result.RCPDetails); // Data List
        this.dataSet = JSON.parse(this.dataSet);
        this.dataTable = $(this.table.nativeElement);
        //Dynamic datable
        let aColList = result.aColListL;
        let dataItem = new DataParam();
        dataItem.acolList = aColList;
        dataItem.aNewButtonName = 'btn_AddNew';
        dataItem.dataTable = this.dataTable;
        dataItem.dataset = this.dataSet;
        dataItem.dtheight = (GlobalConstants.size.height - 350);
        dataItem.modulename = 'DefecMgtDashboard';
        dataItem.rowSelect = true;
        dataItem.infoPopupID = "Id";
        this.dataTable = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable

        $("#tbljournalissue_wrapper tbody tr").each(function () {
          var tdValue = $(this).find('td:eq(7)').text();

          if (tdValue == 'OverDue') {
            $(this).css('color', 'Orange');
          } else {
            $(this).css('color', '');
          }
        });
        $("#LoadingImage").hide();
        if (this.showButton == false) {
          $(".spAddIcon").hide();
          $(".spUpdateIcon").hide();
          $('span[title="Edit"]').hide();

        }

        if (this.mastergridstatus == 'AllAR' || this.mastergridstatus == 'Reject' || this.mastergridstatus == 'Approve') {

          $(".spUpdateIcon").hide();
          $('span[title="Edit"]').hide();
        }
        $('button[title="Add new item"]').attr('title', 'Add New Defect');
        $('span[title="Edit"]').attr('title', 'Response');
        $(".spCol spPopup").attr('title', 'View Response');
        $("#LoadingImage").hide();
      },
      error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      }
    );
  }

  GetDueStatusAllList(eventData: { DueStatuses: any }): void {


    $("#LoadingImage").show();
    var paramData = {
      LoginID: localStorage.aLoginID,
      PublisherID: localStorage.aPubID,
      DueStatuses: eventData.DueStatuses,

    };
    console.log(paramData);
    ApiMethod.postMethod('api/DueStatusGridDetails', paramData).subscribe(
      result => {
        var journalDefectList = result.journalDetails;
        var journalCount = result.journalDetails.length;

        this.dataSet = JSON.stringify(result.DueStatusDetails); // Data List
        this.dataSet = JSON.parse(this.dataSet);
        this.dataTable = $(this.table.nativeElement);
        //Dynamic datable
        let aColList = result.aColListL;
        let dataItem = new DataParam();
        dataItem.acolList = aColList;
        dataItem.aNewButtonName = 'btn_AddNew';
        dataItem.dataTable = this.dataTable;
        dataItem.dataset = this.dataSet;
        dataItem.dtheight = (GlobalConstants.size.height - 350);
        dataItem.modulename = 'DefecMgtDashboard';
        dataItem.rowSelect = true;
        dataItem.infoPopupID = "Id";
        this.dataTable = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable

        $("#tbljournalissue_wrapper tbody tr").each(function () {
          var tdValue = $(this).find('td:eq(7)').text();

          if (tdValue == 'OverDue') {
            $(this).css('color', 'Orange');
          } else {
            $(this).css('color', '');
          }
        });


        $("#LoadingImage").hide();

        if (this.showButton == false) {
          $(".spAddIcon").hide();
          $(".spUpdateIcon").hide();
          $('span[title="Edit"]').hide();

        }

        if (this.mastergridstatus == 'AllAR' || this.mastergridstatus == 'Reject' || this.mastergridstatus == 'Approve') {

          $(".spUpdateIcon").hide();
          $('span[title="Edit"]').hide();
        }
        $('button[title="Add new item"]').attr('title', 'Add New Defect');
        $('span[title="Edit"]').attr('title', 'Response');
        $(".spCol spPopup").attr('title', 'View Response');
        $("#LoadingImage").hide();
      },
      error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      }
    );
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Defect Import Excel Data 
  importExcelPopup() {
    this.showExcelPopupBody = true;
    $("#tblErrorValidation").hide();
    $("#btnUpload").hide();
    $("#errormessageLabel").hide();
  }


  DownloadSupportFiles() {
    ApiMethod.Downloadfile('api/DownloadDefectSampleFile');
  }

  addUpdateImportExcel() {
    $("#LoadingImage").show();
    var filedetails = {
      Id: localStorage.aEID,
      UserName: localStorage.aLoginName,
      fileName: this.file.name,
      fileSize: this.file.size,
      fileAsBase64: this.fileBase64,
    }

    ApiMethod.postMethod('api/ValidateImportExcelFileDefect', filedetails).subscribe(
      response => {
        $("#LoadingImage").hide();
        $('#doc_Importfile').val("");
        this.fileBase64 = "";
        this.LocalFilePath = response.Message;
        if (response.Status == "Success") {
          $("#btnUpload").show();
        }
        else {
          var ExcelData = response.ExcelData;
          console.log(ExcelData);
          if (ExcelData == null) {

            ngswal("Failed !", response.Message, "");
          }
          $("#tblErrorValidation").show();
          //$("#errormessageLabel").show();
          //ngswal("Failed !", "Please review the file you uploaded, make any necessary corrections, and reupload it.", "warning");
          this.ExcelErrorValidations(ExcelData);
        }
      }, error => {

        $("#LoadingImage").hide();
        ngswal("Failed !", error.error.Message, "error");
      });
  }

  addUpdateExcel() {
    var fileexcel = {
      fileLocalPath: this.LocalFilePath
    }
    ApiMethod.postMethod('api/ImportExcelFileDefect', fileexcel).subscribe(
      response => {
        $("#LoadingImage").hide();
        $('#doc_Importfile').val("");
        this.fileBase64 = "";
        if (response.status == "Success") {
          ngswal("Success !", "File Imported Successfully", "success");
          this.showExcelPopupBody = false;
          $('#doc_file').val("");

        }
        else {
          ngswal("Failed !", "File Imported Failed", "error");

        }


      }, error => {

        $("#LoadingImage").hide();
        ngswal("Failed !", error.error.Message, "error");
      });
  }

  ExcelErrorValidations(ExcelData) {
    
    $("#tblErrorValidationList tbody").html("");

    var nRowL: "";
    if (ExcelData.length != 0) {
      nRowL = "";
      for (var i = 0; i < ExcelData.length; i++) {
        nRowL += "<tr id='trExcelData_" + (i + 1).toString() + "'>";
        nRowL += "<td>" + (i + 1).toString() + "</td>";
        nRowL += "<td>" + ExcelData[i].Content + "</td>";
        nRowL += "<td>" + ExcelData[i].Status + "</td>";
        nRowL += "<td>" + ExcelData[i].Remarks + "</td>";
        nRowL += "</tr>";
      }

      $("#tblErrorValidationList tbody").append(nRowL);
    }
    this.showExcelValidationPopup = true;
  }

  // Import Excel bgimp
  onImportSelected(fileInput: any) {

    var ext = $('#doc_file').val().split('.').pop().toLowerCase();
    if ($.inArray(ext, ['xlsx']) == -1) {
      $('#doc_file').val("");
      ngswal("Failed !", "Invalid File format \n Please Refer Sample File", "warning");
      return false;
    } else if (fileInput.target.files[0].size > 52428800) {
      $('#doc_file').val("");
      ngswal("Failed !", "Please upload File less than 50MB", "warning");
      return;
    } else {
      this.file = fileInput.currentTarget.files[0];
      if (fileInput.currentTarget.files[0]) {
        var fileReader = new FileReader();
        fileReader.onload = (e: any) => {
          this.fileBase64 = null;
          this.fileBase64 = e.currentTarget.result;
        }
        fileReader.readAsDataURL(fileInput.currentTarget.files[0]);

      }
      this.Importconfirmation()
    }
  }
  Importconfirmation() {
    if ($('#doc_file').val() == "") {
      $('#doc_file').val("");
      ngswal("Failed !", "Please upload File..!", "warning");
      return;
    }
    ngswal({
      title: "File Upload Confirmation",
      text: this.file.name + "\nAre you sure Submit File?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: '#DD6B55',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      closeOnConfirm: true,
      closeOnCancel: true
    },
      function (isConfirm) {

        if (isConfirm) {
          $('#btnImportvalidation').trigger("click");
          this.file = "";
          this.fileBase64 = null;
        } else {
          $('#doc_file').val("");
          return false;

        }
      });
  };

  hideExcelpopup() {
    this.showExcelPopupBody = false;
    this.clearBudgetdata();

  }
  clearBudgetdata() {
    $("#ExcelPopupBody input[type='file']").val("");
  }

}





